import React from 'react';
import { TopContainer, Area, TopText, RedText, CTAButton } from './index.style';

const Top = ({ onClick, top: { titleBlue, titleRed, cta } }) => (<TopContainer>
    <Area>
        {!!titleBlue &&
            <TopText>
                {titleBlue.text}
                {!!titleRed &&
                    <RedText>{titleRed.text}</RedText>}
            </TopText>}
        {!!cta &&
            <CTAButton onClick={onClick}>{cta.text}</CTAButton>}
    </Area>
</TopContainer>);

export default Top